import Helpers from "./Helpers";
import LoggedInUser from "./LoggedInUser";

class Charge {
  constructor(params) {
    Object.keys(params).forEach(function (attr) {
      this[attr] = params[attr];
    }.bind(this));
  }

  createPayout = async () => {
    const response = await fetch(Helpers.endpoint("/payouts"), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        auth_token: LoggedInUser.getInfo().auth_token,
        stripe_charge_id: this.stripe_charge_id,
      })
    })
    return { isError: !response.ok, ...await response.json() }
  }
}

export default Charge;
